import React, {memo} from "react";
// local
import {IconNotificationCircle} from "components/icons";
import {CustomTooltip} from "components/CustomTooltip";
import {color} from "constants/color.consts";

const containerBaseStyle = {
  height: "20px",
  display: "flex",
  flexFlow: "row nowrap",
  alignItems: "center",
  maxWidth: "max-content",
};
const containerBorderedStyle = {
  border: `1px solid ${color.whiteGray}`,
  borderRadius: "3px",
  padding: "5px 10px 5px 5px",
  height: "30px",
};

export const Info = memo(
  ({
    tooltip,
    text,
    bordered,
    noTranslate,
    centerText,
    addClass,
    addWrapperClass,
    addIconClass,
    addTextClass,

    iconColor,
    iconSize = 20,
  }) => {
    return (
      <CustomTooltip
        text={tooltip}
        centerText={centerText}
        noTranslate={noTranslate}
        addClass={addWrapperClass}
      >
        <div
          style={{...containerBaseStyle, ...(bordered ? containerBorderedStyle : {})}}
          className={addClass}
        >
          <IconNotificationCircle
            color={iconColor || color.black}
            addClass={addIconClass}
            size={iconSize}
          />
          {text && (
            <span className={`fz-13 ml-1 __normal __nonecase ${addTextClass}`}>
              {text}
            </span>
          )}
        </div>
      </CustomTooltip>
    );
  }
);
